
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherAllocateDetailsDialog extends Common.GridEditorDialog<GiftVoucherAllocateDetailsRow> {
        protected getFormKey() { return GiftVoucherAllocateDetailsForm.formKey; }

        protected getLocalTextPrefix() { return GiftVoucherAllocateDetailsRow.localTextPrefix; }


        protected form = new GiftVoucherAllocateDetailsForm(this.idPrefix);

    }
}